// src/app/auth.custom.interceptor.ts

import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { switchMap } from 'rxjs';
import { environment } from '../../../environments/environment';

export const customAuthInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);

  // Define the condition for when to add the token:
  // 1. Must be a call to our own API.
  // 2. Must NOT be the file download path.
  const shouldAttachToken =
    req.url.startsWith(environment.apiBaseUrl) && !req.url.includes('/patients/');

  if (shouldAttachToken) {
    return authService.getAccessTokenSilently().pipe(
      switchMap((token) => {
        const authReq = req.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`,
          },
        });
        return next(authReq);
      })
    );
  } else {
    // For S3 downloads or other requests, pass them through without a token.
    return next(req);
  }
};